import './scss/styles.scss';
import { WebApi } from './components/webApi';
import { API_URL, CDN_URL } from "./utils/constants";
import { EventEmitter } from "./components/base/events";
import { AppData } from './components/appdata';
import { CardsRenderer } from './components/card';
import { cloneTemplate, ensureElement } from "./utils/utils";
import { PayChange } from "./types";
import { Contacts, Shipping } from './components/order';
import { Modal } from './components/modal';
import { Page } from './components/page';
import { Basket } from './components/basket';
import { Success } from './components/success';
// Создание экземпляра событий
const events = new EventEmitter();
const api = new WebApi(CDN_URL, API_URL);
// Получение шаблонов из DOM
const cardCatalogTemplate = ensureElement('#card-catalog');
const cardPreviewTemplate = ensureElement('#card-preview');
const basketTemplate = ensureElement('#basket');
const orderTemplate = ensureElement('#order');
const successTemplate = ensureElement('#success');
const cardBasketTemplate = ensureElement('#card-basket');
const contactsTemplate = ensureElement('#contacts');
// Создание экземпляра модели данных
const appData = new AppData({}, events);
// Создание экземпляров глобальных компонентов
const page = new Page(document.body, events);
const modal = new Modal(ensureElement('#modal-container'), events);
const shipping = new Shipping(cloneTemplate(orderTemplate), events, {
    onClick: function (ev) {
        events.emit('payment:toggle', ev.target);
    }
});
const contact = new Contacts(cloneTemplate(contactsTemplate), events);
const basket = new Basket(cloneTemplate(basketTemplate), events);
// Подписка на изменения в корзине
events.on('basket:changed', (items) => {
    // Обновление отображения корзины
    basket.items = items.map((item, index) => {
        const card = new CardsRenderer(cloneTemplate(cardBasketTemplate), {
            onClick: () => {
                events.emit('product:delete', item);
            },
        });
        return card.render({
            index: (index + 1).toString(),
            title: item.title,
            price: item.price,
        });
    });
    // Пересчет общей суммы в корзине
    const total = items.reduce((total, item) => total + item.price, 0);
    appData.order.total = total;
    basket.total = total;
    basket.buttonBlocked(total === 0);
});
// Подписка на изменение счетчика элементов в корзине
events.on('counter:changed', (item) => {
    page.counter = appData.basket.length;
});
// Подписка на выбор товара из каталога
events.on('card:select', (item) => {
    appData.setPreview(item);
});
// Подписка на изменение выбранного товара
events.on('preview:changed', (item) => {
    // Отображение выбранного товара в модальном окне
    const card = new CardsRenderer(cloneTemplate(cardPreviewTemplate), {
        onClick: () => {
            events.emit('product:toggle', item);
            card.titleBtn = appData.basket.indexOf(item) < 0 ? 'В корзину' : 'Убрать';
        }
    });
    modal.render({
        content: card.render({
            category: item.category,
            title: item.title,
            image: item.image,
            price: item.price,
            description: item.description,
            titleBtn: appData.basket.indexOf(item) < 0 ? 'В корзину' : 'Убрать',
        })
    });
});
// Подписка на добавление/удаление товара из корзины
events.on('product:toggle', (item) => {
    if (appData.basket.indexOf(item) < 0) {
        events.emit('product:add', item);
    }
    else {
        events.emit('product:delete', item);
    }
    ;
});
events.on('product:delete', (item) => appData.removeItem(item));
events.on('product:add', (item) => appData.addItem(item));
// Подписка на изменение способа оплаты
events.on('payment:toggle', (target) => {
    if (!target.classList.contains('button_alt-active')) {
        shipping.toggleButton(target);
        if (!appData.order.payment) {
            appData.order.payment = PayChange[target.getAttribute('name')];
        }
        console.log(appData.order);
    }
});
// Подписка на открытие формы заказа
events.on('order:submit', () => {
    modal.render({
        content: contact.render({
            email: '',
            phone: '',
            valid: false,
            errors: [],
        }),
    });
});
// Подписка на открытие формы заказа
events.on('order:open', () => {
    modal.render({
        content: shipping.render({
            payment: '',
            address: '',
            valid: false,
            errors: []
        })
    });
    appData.order.items = appData.basket.map((item) => {
        return item.id;
    });
});
// Подписка на открытие корзины
events.on('basket:open', () => {
    modal.render({
        content: basket.render({})
    });
});
// Подписка на событие "Контакты заполнены"
events.on('contacts:ok', () => {
    contact.valid = true;
});
// Подписка на событие "Доставка заполнена"
events.on('shipping:ok', () => {
    shipping.valid = true;
});
// Получение списка товаров с сервера
api.getProductList()
    .then(appData.setItems.bind(appData))
    .catch(err => {
    console.error(err);
});
// Подписка на изменение списка товаров в каталоге
events.on('items:changed', () => {
    page.catalog = appData.catalog.map(item => {
        const card = new CardsRenderer(cloneTemplate(cardCatalogTemplate), {
            onClick: () => events.emit('card:select', item)
        });
        return card.render({
            title: item.title,
            image: item.image,
            category: item.category,
            price: item.price
        });
    });
});
// Подписка на отправку формы заказа
events.on('contacts:submit', () => {
    api.orderProduct(appData.order)
        .then((result) => {
        const success = new Success(cloneTemplate(successTemplate), {
            onClick: () => {
                modal.close();
            }
        });
        appData.cleanBasket();
        appData.cleanOrder();
        success.descriptionTotl = result.total.toString();
        modal.render({
            content: success.render({})
        });
    })
        .catch(err => {
        console.error(err);
    });
});
// Подписка на изменение ошибок в форме
events.on('formErrors:change', (errors) => {
    const { payment, address, email, phone } = errors;
    contact.valid = !email && !phone;
    contact.errors = Object.values({ phone, email }).filter(i => !!i).join('; ');
    shipping.valid = !payment && !address;
    shipping.errors = Object.values({ payment, address }).filter(i => !!i).join('; ');
});
// Подписка на изменение данных о доставке
events.on(/^order\..*:change/, (data) => {
    appData.setShipping(data.field, data.value);
});
// Подписка на изменение контактной информации
events.on(/^contacts\..*:change/, (data) => {
    appData.setContacts(data.field, data.value);
});
